module.exports = __webpack_public_path__ + "img/bg_lobby_top.a8e15b25.png";